import React, { Component } from "react";
import {
  withStyles,
  Card,
  CardHeader,
  Avatar,
  Typography,
  CardContent,
  Grid,
  TextField,
  CardActions,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import Add from "@material-ui/icons/Add";

import { PostData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import Rich from "../AddNew/Rich";
import FileUpload from "../AddNew/FileUpload";

const styles = (theme) => ({
  textField: {
    width: "100%",
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing.unit * 2,
  },
});

class AddFeaturedNotification extends Component {
  state = {
    date: "",
    title: "",
    description: "",
    uploadInfo: [],
    is_active: 0,
    open: false,
    message: "",
  };

  __getInitialState() {
    this.setState({
      date: "",
      title: "",
      description: "",
      uploadInfo: [],
      is_active: 0,
    });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleCheckboxChange = (e) => {
    this.setState({
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  handleRichChange = (data) => {
    this.setState({
      description: data,
    });
  };

  onSetFile = (data) => {
    this.setState({
      uploadInfo: data,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    let data = {
      ...this.state,
    };

    PostData(`/${this.props.apikey}/create-featured-notification`, data)
      .then((resp) => {
        this.setState({
          open: true,
          message: resp,
        });
      })
      .then(() => {
        this.__getInitialState();
      });
  };

  render() {
    let { classes } = this.props;

    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
            message={this.state.message}
          />
        ) : null}
        <form onSubmit={this.onSubmit}>
          <Card>
            <CardHeader
              avatar={
                <Avatar>
                  <Add />
                </Avatar>
              }
              title={
                <Typography variant="h6">
                  Add New Featured Notification
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={24}>
                <Grid item lg={4} sm={12}>
                  <TextField
                    label="Date"
                    className={classes.textField}
                    type="date"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required={true}
                    name="date"
                    value={this.state.date}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item lg={8} sm={12}>
                  <FormControlLabel
                    style={{ marginTop: "20px" }}
                    control={
                      <Checkbox
                        checked={this.state.is_active === 1}
                        onChange={this.handleCheckboxChange}
                        name="is_active"
                        color="primary"
                      />
                    }
                    label="Mark as Active (will deactivate all others)"
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <TextField
                    label="Title"
                    className={classes.textField}
                    type="text"
                    margin="normal"
                    variant="outlined"
                    required={true}
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <Rich
                    placeholder="Description....."
                    onChange={this.handleRichChange}
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <FileUpload
                    dp={this.state.uploadInfo}
                    apikey={this.props.apikey}
                    type="featured_notification"
                    setDp={this.onSetFile.bind(this)}
                  />
                </Grid>
              </Grid>
            </CardContent>

            <CardActions>
              <Button variant="outlined" color="primary" type="submit">
                Submit
              </Button>
            </CardActions>
          </Card>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(AddFeaturedNotification);



// WEBPACK FOOTER //
// ./src/Components/FeaturedNotification/AddFeaturedNotification.js